// GENERATED by tools/gen-assets.ts -- do not edit.
// Mirrors the AS3 [Embed] stubs: one class per SWF character symbol.
import { BitmapData, Sound, imageAsset } from "../runtime";

export class BG_endingCity extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("273_BG_endingCity.jpg"));
  }
}

export class BG_endingSunset extends BitmapData {
  constructor(_w = 512, _h = 445) {
    super(512, 445, true, 0, imageAsset("271_BG_endingSunset.jpg"));
  }
}

export class BG_fortress1 extends BitmapData {
  constructor(_w = 481, _h = 344) {
    super(481, 344, true, 0, imageAsset("256_BG_fortress1.png"));
  }
}

export class BG_fortress2 extends BitmapData {
  constructor(_w = 598, _h = 427) {
    super(598, 427, true, 0, imageAsset("255_BG_fortress2.png"));
  }
}

export class BG_fortress3 extends BitmapData {
  constructor(_w = 820, _h = 587) {
    super(820, 587, true, 0, imageAsset("254_BG_fortress3.png"));
  }
}

export class BG_grassyPlains extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("246_BG_grassyPlains.jpg"));
  }
}

export class BG_openingCity extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("209_BG_openingCity.jpg"));
  }
}

export class BG_openingCrenson extends BitmapData {
  constructor(_w = 486, _h = 302) {
    super(486, 302, true, 0, imageAsset("275_BG_openingCrenson.png"));
  }
}

export class EFF_dash extends BitmapData {
  constructor(_w = 256, _h = 256) {
    super(256, 256, true, 0, imageAsset("274_EFF_dash.png"));
  }
}

export class EFF_enemyESlash extends BitmapData {
  constructor(_w = 512, _h = 768) {
    super(512, 768, true, 0, imageAsset("267_EFF_enemyESlash.png"));
  }
}

export class EFF_enemySwipe extends BitmapData {
  constructor(_w = 320, _h = 256) {
    super(320, 256, true, 0, imageAsset("262_EFF_enemySwipe.png"));
  }
}

export class EFF_enemySwordCharge extends BitmapData {
  constructor(_w = 128, _h = 96) {
    super(128, 96, true, 0, imageAsset("260_EFF_enemySwordCharge.png"));
  }
}

export class EFF_enemySwordChargeBig extends BitmapData {
  constructor(_w = 256, _h = 192) {
    super(256, 192, true, 0, imageAsset("261_EFF_enemySwordChargeBig.png"));
  }
}

export class EFF_explode extends BitmapData {
  constructor(_w = 256, _h = 192) {
    super(256, 192, true, 0, imageAsset("206_EFF_explode.png"));
  }
}

export class EFF_explodeB extends BitmapData {
  constructor(_w = 128, _h = 128) {
    super(128, 128, true, 0, imageAsset("259_EFF_explodeB.png"));
  }
}

export class EFF_explodeC extends BitmapData {
  constructor(_w = 512, _h = 384) {
    super(512, 384, true, 0, imageAsset("207_EFF_explodeC.png"));
  }
}

export class EFF_explodeSpike extends BitmapData {
  constructor(_w = 256, _h = 192) {
    super(256, 192, true, 0, imageAsset("257_EFF_explodeSpike.png"));
  }
}

export class EFF_playerHit extends BitmapData {
  constructor(_w = 32, _h = 32) {
    super(32, 32, true, 0, imageAsset("243_EFF_playerHit.png"));
  }
}

export class EFF_playerTrail extends BitmapData {
  constructor(_w = 192, _h = 144) {
    super(192, 144, true, 0, imageAsset("194_EFF_playerTrail.png"));
  }
}

export class EFF_playerTrail2 extends BitmapData {
  constructor(_w = 192, _h = 144) {
    super(192, 144, true, 0, imageAsset("195_EFF_playerTrail2.png"));
  }
}

export class EFF_shotAbsorb extends BitmapData {
  constructor(_w = 144, _h = 144) {
    super(144, 144, true, 0, imageAsset("174_EFF_shotAbsorb.png"));
  }
}

export class EFF_smoke extends BitmapData {
  constructor(_w = 192, _h = 144) {
    super(192, 144, true, 0, imageAsset("172_EFF_smoke.png"));
  }
}

export class EFF_spark extends BitmapData {
  constructor(_w = 320, _h = 128) {
    super(320, 128, true, 0, imageAsset("244_EFF_spark.png"));
  }
}

export class EFF_strike0 extends BitmapData {
  constructor(_w = 32, _h = 32) {
    super(32, 32, true, 0, imageAsset("171_EFF_strike0.png"));
  }
}

export class EFF_strike1 extends BitmapData {
  constructor(_w = 32, _h = 32) {
    super(32, 32, true, 0, imageAsset("170_EFF_strike1.png"));
  }
}

export class EFF_strike2 extends BitmapData {
  constructor(_w = 32, _h = 32) {
    super(32, 32, true, 0, imageAsset("169_EFF_strike2.png"));
  }
}

export class EFF_strike3 extends BitmapData {
  constructor(_w = 32, _h = 32) {
    super(32, 32, true, 0, imageAsset("168_EFF_strike3.png"));
  }
}

export class EFF_strikeX extends BitmapData {
  constructor(_w = 64, _h = 64) {
    super(64, 64, true, 0, imageAsset("167_EFF_strikeX.png"));
  }
}

export class EFF_warpInA extends BitmapData {
  constructor(_w = 512, _h = 256) {
    super(512, 256, true, 0, imageAsset("155_EFF_warpInA.png"));
  }
}

export class EFF_warpInB extends BitmapData {
  constructor(_w = 1024, _h = 512) {
    super(1024, 512, true, 0, imageAsset("154_EFF_warpInB.png"));
  }
}

export class G_HL1 extends BitmapData {
  constructor(_w = 481, _h = 51) {
    super(481, 51, true, 0, imageAsset("242_G_HL1.png"));
  }
}

export class G_HL2 extends BitmapData {
  constructor(_w = 481, _h = 33) {
    super(481, 33, true, 0, imageAsset("241_G_HL2.png"));
  }
}

export class G_HL3 extends BitmapData {
  constructor(_w = 513, _h = 66) {
    super(513, 66, true, 0, imageAsset("240_G_HL3.png"));
  }
}

export class G_arrow extends BitmapData {
  constructor(_w = 23, _h = 39) {
    super(23, 39, true, 0, imageAsset("175_G_arrow.png"));
  }
}

export class G_back extends BitmapData {
  constructor(_w = 76, _h = 74) {
    super(76, 74, true, 0, imageAsset("292_G_back.png"));
  }
}

export class G_bgCircuit extends BitmapData {
  constructor(_w = 720, _h = 480) {
    super(720, 480, true, 0, imageAsset("158_G_bgCircuit.png"));
  }
}

export class G_bgCircuit2 extends BitmapData {
  constructor(_w = 720, _h = 480) {
    super(720, 480, true, 0, imageAsset("222_G_bgCircuit2.png"));
  }
}

export class G_bossBar extends BitmapData {
  constructor(_w = 102, _h = 13) {
    super(102, 13, true, 0, imageAsset("282_G_bossBar.png"));
  }
}

export class G_bossBarBit extends BitmapData {
  constructor(_w = 7, _h = 9) {
    super(7, 9, true, 0, imageAsset("281_G_bossBarBit.png"));
  }
}

export class G_circuitBack extends BitmapData {
  constructor(_w = 512, _h = 48) {
    super(512, 48, true, 0, imageAsset("279_G_circuitBack.png"));
  }
}

export class G_city extends BitmapData {
  constructor(_w = 720, _h = 480) {
    super(720, 480, true, 0, imageAsset("277_G_city.jpg"));
  }
}

export class G_fortress extends BitmapData {
  constructor(_w = 187, _h = 157) {
    super(187, 157, true, 0, imageAsset("252_G_fortress.png"));
  }
}

export class G_fortressCutScene extends BitmapData {
  constructor(_w = 226, _h = 156) {
    super(226, 156, true, 0, imageAsset("251_G_fortressCutScene.png"));
  }
}

export class G_fortressCutScene2 extends BitmapData {
  constructor(_w = 224, _h = 156) {
    super(224, 156, true, 0, imageAsset("250_G_fortressCutScene2.png"));
  }
}

export class G_fortressShadow extends BitmapData {
  constructor(_w = 238, _h = 148) {
    super(238, 148, true, 0, imageAsset("253_G_fortressShadow.png"));
  }
}

export class G_gradRed extends BitmapData {
  constructor(_w = 64, _h = 64) {
    super(64, 64, true, 0, imageAsset("247_G_gradRed.png"));
  }
}

export class G_hudMain extends BitmapData {
  constructor(_w = 720, _h = 80) {
    super(720, 80, true, 0, imageAsset("238_G_hudMain.png"));
  }
}

export class G_itemSlot extends BitmapData {
  constructor(_w = 42, _h = 42) {
    super(42, 42, true, 0, imageAsset("234_G_itemSlot.png"));
  }
}

export class G_levelTypeHolder extends BitmapData {
  constructor(_w = 48, _h = 48) {
    super(48, 48, true, 0, imageAsset("229_G_levelTypeHolder.png"));
  }
}

export class G_lifeBar extends BitmapData {
  constructor(_w = 174, _h = 8) {
    super(174, 8, true, 0, imageAsset("228_G_lifeBar.png"));
  }
}

export class G_lifeBarBack extends BitmapData {
  constructor(_w = 174, _h = 8) {
    super(174, 8, true, 0, imageAsset("227_G_lifeBarBack.png"));
  }
}

export class G_lifeOctagon extends BitmapData {
  constructor(_w = 49, _h = 48) {
    super(49, 48, true, 0, imageAsset("239_G_lifeOctagon.png"));
  }
}

export class G_mapPoint extends BitmapData {
  constructor(_w = 14, _h = 14) {
    super(14, 14, true, 0, imageAsset("226_G_mapPoint.png"));
  }
}

export class G_mapPointCrenson extends BitmapData {
  constructor(_w = 38, _h = 38) {
    super(38, 38, true, 0, imageAsset("225_G_mapPointCrenson.png"));
  }
}

export class G_mapPointCrenson2 extends BitmapData {
  constructor(_w = 48, _h = 48) {
    super(48, 48, true, 0, imageAsset("224_G_mapPointCrenson2.png"));
  }
}

export class G_mapPointSelected extends BitmapData {
  constructor(_w = 48, _h = 48) {
    super(48, 48, true, 0, imageAsset("223_G_mapPointSelected.png"));
  }
}

export class G_menuBox extends BitmapData {
  constructor(_w = 240, _h = 64) {
    super(240, 64, true, 0, imageAsset("221_G_menuBox.png"));
  }
}

export class G_menuBoxNarrow extends BitmapData {
  constructor(_w = 188, _h = 47) {
    super(188, 47, true, 0, imageAsset("220_G_menuBoxNarrow.png"));
  }
}

export class G_menuBoxSmall extends BitmapData {
  constructor(_w = 96, _h = 64) {
    super(96, 64, true, 0, imageAsset("219_G_menuBoxSmall.png"));
  }
}

export class G_menuBoxSmallHighlight extends BitmapData {
  constructor(_w = 142, _h = 68) {
    super(142, 68, true, 0, imageAsset("218_G_menuBoxSmallHighlight.png"));
  }
}

export class G_messageBox extends BitmapData {
  constructor(_w = 270, _h = 75) {
    super(270, 75, true, 0, imageAsset("217_G_messageBox.png"));
  }
}

export class G_mmBlob1 extends BitmapData {
  constructor(_w = 5, _h = 5) {
    super(5, 5, true, 0, imageAsset("214_G_mmBlob1.png"));
  }
}

export class G_mmBlob2 extends BitmapData {
  constructor(_w = 5, _h = 5) {
    super(5, 5, true, 0, imageAsset("213_G_mmBlob2.png"));
  }
}

export class G_oddityLogo extends BitmapData {
  constructor(_w = 221, _h = 60) {
    super(221, 60, true, 0, imageAsset("210_G_oddityLogo.png"));
  }
}

export class G_openingTunnel extends BitmapData {
  constructor(_w = 512, _h = 380) {
    super(512, 380, true, 0, imageAsset("208_G_openingTunnel.png"));
  }
}

export class G_portraitHolder extends BitmapData {
  constructor(_w = 128, _h = 128) {
    super(128, 128, true, 0, imageAsset("193_G_portraitHolder.png"));
  }
}

export class G_roadStraight extends BitmapData {
  constructor(_w = 42, _h = 42) {
    super(42, 42, true, 0, imageAsset("183_G_roadStraight.png"));
  }
}

export class G_roadTurnBig extends BitmapData {
  constructor(_w = 42, _h = 42) {
    super(42, 42, true, 0, imageAsset("182_G_roadTurnBig.png"));
  }
}

export class G_roadTurnLong extends BitmapData {
  constructor(_w = 42, _h = 42) {
    super(42, 42, true, 0, imageAsset("181_G_roadTurnLong.png"));
  }
}

export class G_roadTurnLongB extends BitmapData {
  constructor(_w = 42, _h = 42) {
    super(42, 42, true, 0, imageAsset("180_G_roadTurnLongB.png"));
  }
}

export class G_roadTurnSmall extends BitmapData {
  constructor(_w = 42, _h = 42) {
    super(42, 42, true, 0, imageAsset("179_G_roadTurnSmall.png"));
  }
}

export class G_roadTurnSmallB extends BitmapData {
  constructor(_w = 42, _h = 42) {
    super(42, 42, true, 0, imageAsset("178_G_roadTurnSmallB.png"));
  }
}

export class G_robot extends BitmapData {
  constructor(_w = 218, _h = 307) {
    super(218, 307, true, 0, imageAsset("176_G_robot.png"));
  }
}

export class G_robotInner extends BitmapData {
  constructor(_w = 218, _h = 307) {
    super(218, 307, true, 0, imageAsset("177_G_robotInner.png"));
  }
}

export class G_startMissionBar extends BitmapData {
  constructor(_w = 512, _h = 88) {
    super(512, 88, true, 0, imageAsset("211_G_startMissionBar.png"));
  }
}

export class G_textBox extends BitmapData {
  constructor(_w = 640, _h = 160) {
    super(640, 160, true, 0, imageAsset("159_G_textBox.png"));
  }
}

export class G_unlockBox extends BitmapData {
  constructor(_w = 512, _h = 118) {
    super(512, 118, true, 0, imageAsset("156_G_unlockBox.png"));
  }
}

export class G_w1 extends BitmapData {
  constructor(_w = 50, _h = 50) {
    super(50, 50, true, 0, imageAsset("304_G_w1.png"));
  }
}

export class G_w1s extends BitmapData {
  constructor(_w = 36, _h = 35) {
    super(36, 35, true, 0, imageAsset("303_G_w1s.png"));
  }
}

export class G_w2 extends BitmapData {
  constructor(_w = 50, _h = 50) {
    super(50, 50, true, 0, imageAsset("302_G_w2.png"));
  }
}

export class G_w2s extends BitmapData {
  constructor(_w = 36, _h = 35) {
    super(36, 35, true, 0, imageAsset("301_G_w2s.png"));
  }
}

export class G_w3 extends BitmapData {
  constructor(_w = 50, _h = 50) {
    super(50, 50, true, 0, imageAsset("300_G_w3.png"));
  }
}

export class G_w3s extends BitmapData {
  constructor(_w = 36, _h = 35) {
    super(36, 35, true, 0, imageAsset("299_G_w3s.png"));
  }
}

export class G_w4 extends BitmapData {
  constructor(_w = 50, _h = 50) {
    super(50, 50, true, 0, imageAsset("298_G_w4.png"));
  }
}

export class G_w4s extends BitmapData {
  constructor(_w = 36, _h = 35) {
    super(36, 35, true, 0, imageAsset("297_G_w4s.png"));
  }
}

export class G_w5 extends BitmapData {
  constructor(_w = 50, _h = 50) {
    super(50, 50, true, 0, imageAsset("296_G_w5.png"));
  }
}

export class G_w5s extends BitmapData {
  constructor(_w = 36, _h = 35) {
    super(36, 35, true, 0, imageAsset("295_G_w5s.png"));
  }
}

export class G_weaponBar extends BitmapData {
  constructor(_w = 220, _h = 55) {
    super(220, 55, true, 0, imageAsset("237_G_weaponBar.png"));
  }
}

export class G_whiteFill extends BitmapData {
  constructor(_w = 720, _h = 480) {
    super(720, 480, true, 0, imageAsset("152_G_whiteFill.jpg"));
  }
}

export class G_xenosAlpha extends BitmapData {
  constructor(_w = 170, _h = 42) {
    super(170, 42, true, 0, imageAsset("294_G_xenosAlpha.png"));
  }
}

export class G_xenosBar extends BitmapData {
  constructor(_w = 170, _h = 42) {
    super(170, 42, true, 0, imageAsset("150_G_xenosBar.png"));
  }
}

export class G_xenosBarBack extends BitmapData {
  constructor(_w = 170, _h = 42) {
    super(170, 42, true, 0, imageAsset("151_G_xenosBarBack.png"));
  }
}

export class M_title extends BitmapData {
  constructor(_w = 720, _h = 74) {
    super(720, 74, true, 0, imageAsset("157_M_title.png"));
  }
}

export class SPR_axeShockwave extends BitmapData {
  constructor(_w = 384, _h = 256) {
    super(384, 256, true, 0, imageAsset("293_SPR_axeShockwave.png"));
  }
}

export class SPR_barrierBeam extends BitmapData {
  constructor(_w = 384, _h = 256) {
    super(384, 256, true, 0, imageAsset("290_SPR_barrierBeam.png"));
  }
}

export class SPR_barrierBlock extends BitmapData {
  constructor(_w = 512, _h = 256) {
    super(512, 256, true, 0, imageAsset("289_SPR_barrierBlock.png"));
  }
}

export class SPR_blackhole extends BitmapData {
  constructor(_w = 512, _h = 384) {
    super(512, 384, true, 0, imageAsset("286_SPR_blackhole.png"));
  }
}

export class SPR_boss1 extends BitmapData {
  constructor(_w = 768, _h = 768) {
    super(768, 768, true, 0, imageAsset("285_SPR_boss1.png"));
  }
}

export class SPR_boss2 extends BitmapData {
  constructor(_w = 576, _h = 576) {
    super(576, 576, true, 0, imageAsset("284_SPR_boss2.png"));
  }
}

export class SPR_bossFinal extends BitmapData {
  constructor(_w = 640, _h = 640) {
    super(640, 640, true, 0, imageAsset("283_SPR_bossFinal.png"));
  }
}

export class SPR_circuit extends BitmapData {
  constructor(_w = 96, _h = 96) {
    super(96, 96, true, 0, imageAsset("278_SPR_circuit.png"));
  }
}

export class SPR_circuit2 extends BitmapData {
  constructor(_w = 96, _h = 96) {
    super(96, 96, true, 0, imageAsset("280_SPR_circuit2.png"));
  }
}

export class SPR_cleanser extends BitmapData {
  constructor(_w = 320, _h = 320) {
    super(320, 320, true, 0, imageAsset("276_SPR_cleanser.png"));
  }
}

export class SPR_enemyA extends BitmapData {
  constructor(_w = 336, _h = 210) {
    super(336, 210, true, 0, imageAsset("263_SPR_enemyA.png"));
  }
}

export class SPR_enemyB extends BitmapData {
  constructor(_w = 512, _h = 448) {
    super(512, 448, true, 0, imageAsset("270_SPR_enemyB.png"));
  }
}

export class SPR_enemyC extends BitmapData {
  constructor(_w = 512, _h = 448) {
    super(512, 448, true, 0, imageAsset("269_SPR_enemyC.png"));
  }
}

export class SPR_enemyD extends BitmapData {
  constructor(_w = 384, _h = 288) {
    super(384, 288, true, 0, imageAsset("268_SPR_enemyD.png"));
  }
}

export class SPR_enemyE extends BitmapData {
  constructor(_w = 1280, _h = 768) {
    super(1280, 768, true, 0, imageAsset("266_SPR_enemyE.png"));
  }
}

export class SPR_enemyF extends BitmapData {
  constructor(_w = 1280, _h = 768) {
    super(1280, 768, true, 0, imageAsset("265_SPR_enemyF.png"));
  }
}

export class SPR_enemyLaser extends BitmapData {
  constructor(_w = 192, _h = 192) {
    super(192, 192, true, 0, imageAsset("230_SPR_enemyLaser.png"));
  }
}

export class SPR_enemyShot extends BitmapData {
  constructor(_w = 48, _h = 48) {
    super(48, 48, true, 0, imageAsset("264_SPR_enemyShot.png"));
  }
}

export class SPR_explodeHuge extends BitmapData {
  constructor(_w = 384, _h = 288) {
    super(384, 288, true, 0, imageAsset("258_SPR_explodeHuge.png"));
  }
}

export class SPR_generator extends BitmapData {
  constructor(_w = 480, _h = 768) {
    super(480, 768, true, 0, imageAsset("248_SPR_generator.png"));
  }
}

export class SPR_generatorBroken extends BitmapData {
  constructor(_w = 96, _h = 96) {
    super(96, 96, true, 0, imageAsset("249_SPR_generatorBroken.png"));
  }
}

export class SPR_gravityOrb extends BitmapData {
  constructor(_w = 64, _h = 64) {
    super(64, 64, true, 0, imageAsset("245_SPR_gravityOrb.png"));
  }
}

export class SPR_itemHP extends BitmapData {
  constructor(_w = 128, _h = 128) {
    super(128, 128, true, 0, imageAsset("236_SPR_itemHP.png"));
  }
}

export class SPR_itemPickup extends BitmapData {
  constructor(_w = 192, _h = 192) {
    super(192, 192, true, 0, imageAsset("235_SPR_itemPickup.png"));
  }
}

export class SPR_itemXenos extends BitmapData {
  constructor(_w = 192, _h = 192) {
    super(192, 192, true, 0, imageAsset("233_SPR_itemXenos.png"));
  }
}

export class SPR_knight extends BitmapData {
  constructor(_w = 640, _h = 512) {
    super(640, 512, true, 0, imageAsset("231_SPR_knight.png"));
  }
}

export class SPR_knightArmoured extends BitmapData {
  constructor(_w = 640, _h = 512) {
    super(640, 512, true, 0, imageAsset("232_SPR_knightArmoured.png"));
  }
}

export class SPR_mine extends BitmapData {
  constructor(_w = 288, _h = 192) {
    super(288, 192, true, 0, imageAsset("215_SPR_mine.png"));
  }
}

export class SPR_missile extends BitmapData {
  constructor(_w = 288, _h = 288) {
    super(288, 288, true, 0, imageAsset("212_SPR_missile.png"));
  }
}

export class SPR_portraitDistort extends BitmapData {
  constructor(_w = 384, _h = 256) {
    super(384, 256, true, 0, imageAsset("185_SPR_portraitDistort.png"));
  }
}

export class SPR_rain extends BitmapData {
  constructor(_w = 128, _h = 128) {
    super(128, 128, true, 0, imageAsset("184_SPR_rain.png"));
  }
}

export class SPR_sickleShot extends BitmapData {
  constructor(_w = 128, _h = 96) {
    super(128, 96, true, 0, imageAsset("173_SPR_sickleShot.png"));
  }
}

export class SPR_sword extends BitmapData {
  constructor(_w = 320, _h = 256) {
    super(320, 256, true, 0, imageAsset("165_SPR_sword.png"));
  }
}

export class SPR_swordBack extends BitmapData {
  constructor(_w = 128, _h = 256) {
    super(128, 256, true, 0, imageAsset("166_SPR_swordBack.png"));
  }
}

export class SPR_swordTrail extends BitmapData {
  constructor(_w = 640, _h = 256) {
    super(640, 256, true, 0, imageAsset("163_SPR_swordTrail.png"));
  }
}

export class SPR_swordTrailBack extends BitmapData {
  constructor(_w = 256, _h = 256) {
    super(256, 256, true, 0, imageAsset("164_SPR_swordTrailBack.png"));
  }
}

export class blackBlock extends BitmapData {
  constructor(_w = 32, _h = 32) {
    super(32, 32, true, 0, imageAsset("288_blackBlock.png"));
  }
}

export class blackBlock2 extends BitmapData {
  constructor(_w = 32, _h = 32) {
    super(32, 32, true, 0, imageAsset("287_blackBlock2.png"));
  }
}

export class endingExplode extends BitmapData {
  constructor(_w = 99, _h = 99) {
    super(99, 99, true, 0, imageAsset("272_endingExplode.png"));
  }
}

export class enemyHPBar extends BitmapData {
  constructor(_w = 41, _h = 8) {
    super(41, 8, true, 0, imageAsset("291_enemyHPBar.png"));
  }
}

export class mDot extends BitmapData {
  constructor(_w = 3, _h = 4) {
    super(3, 4, true, 0, imageAsset("216_mDot.png"));
  }
}

export class pPose1 extends BitmapData {
  constructor(_w = 383, _h = 219) {
    super(383, 219, true, 0, imageAsset("205_pPose1.png"));
  }
}

export class pPoseArmour1 extends BitmapData {
  constructor(_w = 383, _h = 228) {
    super(383, 228, true, 0, imageAsset("202_pPoseArmour1.png"));
  }
}

export class pPoseArmourSunset1 extends BitmapData {
  constructor(_w = 250, _h = 238) {
    super(250, 238, true, 0, imageAsset("200_pPoseArmourSunset1.png"));
  }
}

export class pPoseArmourSunset2 extends BitmapData {
  constructor(_w = 377, _h = 231) {
    super(377, 231, true, 0, imageAsset("201_pPoseArmourSunset2.png"));
  }
}

export class pPoseSunset1 extends BitmapData {
  constructor(_w = 224, _h = 238) {
    super(224, 238, true, 0, imageAsset("203_pPoseSunset1.png"));
  }
}

export class pPoseSunset2 extends BitmapData {
  constructor(_w = 377, _h = 211) {
    super(377, 211, true, 0, imageAsset("204_pPoseSunset2.png"));
  }
}

export class playerF1 extends BitmapData {
  constructor(_w = 9, _h = 9) {
    super(9, 9, true, 0, imageAsset("199_playerF1.png"));
  }
}

export class playerF2 extends BitmapData {
  constructor(_w = 9, _h = 9) {
    super(9, 9, true, 0, imageAsset("198_playerF2.png"));
  }
}

export class playerF3 extends BitmapData {
  constructor(_w = 9, _h = 9) {
    super(9, 9, true, 0, imageAsset("197_playerF3.png"));
  }
}

export class playerF4 extends BitmapData {
  constructor(_w = 9, _h = 9) {
    super(9, 9, true, 0, imageAsset("196_playerF4.png"));
  }
}

export class portrait_A1 extends BitmapData {
  constructor(_w = 128, _h = 128) {
    super(128, 128, true, 0, imageAsset("192_portrait_A1.jpg"));
  }
}

export class portrait_A2 extends BitmapData {
  constructor(_w = 128, _h = 128) {
    super(128, 128, true, 0, imageAsset("191_portrait_A2.jpg"));
  }
}

export class portrait_C1 extends BitmapData {
  constructor(_w = 128, _h = 128) {
    super(128, 128, true, 0, imageAsset("190_portrait_C1.png"));
  }
}

export class portrait_C2 extends BitmapData {
  constructor(_w = 128, _h = 128) {
    super(128, 128, true, 0, imageAsset("189_portrait_C2.png"));
  }
}

export class portrait_G1 extends BitmapData {
  constructor(_w = 128, _h = 128) {
    super(128, 128, true, 0, imageAsset("188_portrait_G1.png"));
  }
}

export class portrait_G2 extends BitmapData {
  constructor(_w = 128, _h = 128) {
    super(128, 128, true, 0, imageAsset("187_portrait_G2.png"));
  }
}

export class portrait_X1 extends BitmapData {
  constructor(_w = 128, _h = 128) {
    super(128, 128, true, 0, imageAsset("186_portrait_X1.jpg"));
  }
}

export class targetF1 extends BitmapData {
  constructor(_w = 9, _h = 9) {
    super(9, 9, true, 0, imageAsset("162_targetF1.png"));
  }
}

export class targetF2 extends BitmapData {
  constructor(_w = 9, _h = 9) {
    super(9, 9, true, 0, imageAsset("161_targetF2.png"));
  }
}

export class targetF3 extends BitmapData {
  constructor(_w = 9, _h = 9) {
    super(9, 9, true, 0, imageAsset("160_targetF3.png"));
  }
}

export class whiteBlock extends BitmapData {
  constructor(_w = 32, _h = 32) {
    super(32, 32, true, 0, imageAsset("153_whiteBlock.jpg"));
  }
}

export class zone1Block1 extends BitmapData {
  constructor(_w = 64, _h = 64) {
    super(64, 64, true, 0, imageAsset("146_zone1Block1.png"));
  }
}

export class zone1Block2 extends BitmapData {
  constructor(_w = 64, _h = 64) {
    super(64, 64, true, 0, imageAsset("145_zone1Block2.png"));
  }
}

export class zone1Obs extends BitmapData {
  constructor(_w = 3072, _h = 3072) {
    super(3072, 3072, true, 0, imageAsset("141_zone1Obs.png"));
  }
}

export class zone2Block1 extends BitmapData {
  constructor(_w = 64, _h = 64) {
    super(64, 64, true, 0, imageAsset("137_zone2Block1.png"));
  }
}

export class zone2Block2 extends BitmapData {
  constructor(_w = 64, _h = 64) {
    super(64, 64, true, 0, imageAsset("136_zone2Block2.png"));
  }
}

export class zone2Obs extends BitmapData {
  constructor(_w = 3072, _h = 3072) {
    super(3072, 3072, true, 0, imageAsset("135_zone2Obs.png"));
  }
}

export class zone3Block1 extends BitmapData {
  constructor(_w = 64, _h = 64) {
    super(64, 64, true, 0, imageAsset("124_zone3Block1.png"));
  }
}

export class zone3Block2 extends BitmapData {
  constructor(_w = 64, _h = 64) {
    super(64, 64, true, 0, imageAsset("123_zone3Block2.png"));
  }
}

export class zone3Obs extends BitmapData {
  constructor(_w = 3072, _h = 3072) {
    super(3072, 3072, true, 0, imageAsset("122_zone3Obs.png"));
  }
}

export class zoneCityDaybgBottom extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("144_zoneCityDaybgBottom.jpg"));
  }
}

export class zoneCityDaybgMiddle extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("143_zoneCityDaybgMiddle.jpg"));
  }
}

export class zoneCityDaybgTop extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("142_zoneCityDaybgTop.jpg"));
  }
}

export class zoneCitybgBottom extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("149_zoneCitybgBottom.jpg"));
  }
}

export class zoneCitybgMiddle extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("148_zoneCitybgMiddle.jpg"));
  }
}

export class zoneCitybgTop extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("147_zoneCitybgTop.jpg"));
  }
}

export class zoneDaybgBottom extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("140_zoneDaybgBottom.jpg"));
  }
}

export class zoneDaybgMiddle extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("139_zoneDaybgMiddle.jpg"));
  }
}

export class zoneDaybgTop extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("138_zoneDaybgTop.jpg"));
  }
}

export class zoneFortressbgMiddle extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("134_zoneFortressbgMiddle.jpg"));
  }
}

export class zoneNightbgBottom extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("133_zoneNightbgBottom.jpg"));
  }
}

export class zoneNightbgMiddle extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("132_zoneNightbgMiddle.jpg"));
  }
}

export class zoneNightbgTop extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("131_zoneNightbgTop.jpg"));
  }
}

export class zoneSunsetbgBottom extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("130_zoneSunsetbgBottom.jpg"));
  }
}

export class zoneSunsetbgMiddle extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("129_zoneSunsetbgMiddle.jpg"));
  }
}

export class zoneSunsetbgTop extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("128_zoneSunsetbgTop.jpg"));
  }
}

export class zoneUndergroundbgBottom extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("127_zoneUndergroundbgBottom.jpg"));
  }
}

export class zoneUndergroundbgMiddle extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("126_zoneUndergroundbgMiddle.jpg"));
  }
}

export class zoneUndergroundbgTop extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("125_zoneUndergroundbgTop.jpg"));
  }
}

export class zoneVRbg extends BitmapData {
  constructor(_w = 512, _h = 512) {
    super(512, 512, true, 0, imageAsset("121_zoneVRbg.jpg"));
  }
}

export class FX_appear extends Sound {
  constructor() {
    super("120_FX_appear");
  }
}

export class FX_axeCharge extends Sound {
  constructor() {
    super("119_FX_axeCharge");
  }
}

export class FX_axeShockwave extends Sound {
  constructor() {
    super("118_FX_axeShockwave");
  }
}

export class FX_cleanserLoop extends Sound {
  constructor() {
    super("115_FX_cleanserLoop");
  }
}

export class FX_damage extends Sound {
  constructor() {
    super("114_FX_damage");
  }
}

export class FX_dash extends Sound {
  constructor() {
    super("113_FX_dash");
  }
}

export class FX_death extends Sound {
  constructor() {
    super("112_FX_death");
  }
}

export class FX_doors extends Sound {
  constructor() {
    super("111_FX_doors");
  }
}

export class FX_effect1 extends Sound {
  constructor() {
    super("109_FX_effect1");
  }
}

export class FX_effect2 extends Sound {
  constructor() {
    super("108_FX_effect2");
  }
}

export class FX_effect3 extends Sound {
  constructor() {
    super("110_FX_effect3");
  }
}

export class FX_enemyShot1 extends Sound {
  constructor() {
    super("106_FX_enemyShot1");
  }
}

export class FX_enemyShot2 extends Sound {
  constructor() {
    super("105_FX_enemyShot2");
  }
}

export class FX_enemyShot3 extends Sound {
  constructor() {
    super("104_FX_enemyShot3");
  }
}

export class FX_enemySlash extends Sound {
  constructor() {
    super("103_FX_enemySlash");
  }
}

export class FX_explode1 extends Sound {
  constructor() {
    super("102_FX_explode1");
  }
}

export class FX_explode2 extends Sound {
  constructor() {
    super("101_FX_explode2");
  }
}

export class FX_explode3 extends Sound {
  constructor() {
    super("100_FX_explode3");
  }
}

export class FX_explode4 extends Sound {
  constructor() {
    super("99_FX_explode4");
  }
}

export class FX_explode5 extends Sound {
  constructor() {
    super("98_FX_explode5");
  }
}

export class FX_explode6 extends Sound {
  constructor() {
    super("97_FX_explode6");
  }
}

export class FX_hit1 extends Sound {
  constructor() {
    super("96_FX_hit1");
  }
}

export class FX_hit2 extends Sound {
  constructor() {
    super("95_FX_hit2");
  }
}

export class FX_hit3 extends Sound {
  constructor() {
    super("94_FX_hit3");
  }
}

export class FX_hitSpecial1 extends Sound {
  constructor() {
    super("93_FX_hitSpecial1");
  }
}

export class FX_hitSpecial2 extends Sound {
  constructor() {
    super("92_FX_hitSpecial2");
  }
}

export class FX_hitSpecial3 extends Sound {
  constructor() {
    super("91_FX_hitSpecial3");
  }
}

export class FX_item1 extends Sound {
  constructor() {
    super("90_FX_item1");
  }
}

export class FX_item2 extends Sound {
  constructor() {
    super("89_FX_item2");
  }
}

export class FX_item3 extends Sound {
  constructor() {
    super("88_FX_item3");
  }
}

export class FX_menuChange1 extends Sound {
  constructor() {
    super("80_FX_menuChange1");
  }
}

export class FX_menuChange2 extends Sound {
  constructor() {
    super("79_FX_menuChange2");
  }
}

export class FX_menuSelect1 extends Sound {
  constructor() {
    super("78_FX_menuSelect1");
  }
}

export class FX_mine1 extends Sound {
  constructor() {
    super("77_FX_mine1");
  }
}

export class FX_mine2 extends Sound {
  constructor() {
    super("76_FX_mine2");
  }
}

export class FX_missileLaunch extends Sound {
  constructor() {
    super("75_FX_missileLaunch");
  }
}

export class FX_missionBar1 extends Sound {
  constructor() {
    super("74_FX_missionBar1");
  }
}

export class FX_missionBar2 extends Sound {
  constructor() {
    super("73_FX_missionBar2");
  }
}

export class FX_openingBoost extends Sound {
  constructor() {
    super("71_FX_openingBoost");
  }
}

export class FX_openingComputer extends Sound {
  constructor() {
    super("70_FX_openingComputer");
  }
}

export class FX_scytheBlackHole extends Sound {
  constructor() {
    super("69_FX_scytheBlackHole");
  }
}

export class FX_scytheShot extends Sound {
  constructor() {
    super("68_FX_scytheShot");
  }
}

export class FX_shine extends Sound {
  constructor() {
    super("67_FX_shine");
  }
}

export class FX_staffCatch extends Sound {
  constructor() {
    super("66_FX_staffCatch");
  }
}

export class FX_staffSpin extends Sound {
  constructor() {
    super("65_FX_staffSpin");
  }
}

export class FX_staffThrow extends Sound {
  constructor() {
    super("64_FX_staffThrow");
  }
}

export class FX_swipe1 extends Sound {
  constructor() {
    super("63_FX_swipe1");
  }
}

export class FX_swipe2 extends Sound {
  constructor() {
    super("62_FX_swipe2");
  }
}

export class FX_swipe3 extends Sound {
  constructor() {
    super("61_FX_swipe3");
  }
}

export class FX_swipeB1 extends Sound {
  constructor() {
    super("60_FX_swipeB1");
  }
}

export class FX_swipeB2 extends Sound {
  constructor() {
    super("59_FX_swipeB2");
  }
}

export class FX_swipeB3 extends Sound {
  constructor() {
    super("58_FX_swipeB3");
  }
}

export class FX_swipeC1 extends Sound {
  constructor() {
    super("57_FX_swipeC1");
  }
}

export class FX_swipeC2 extends Sound {
  constructor() {
    super("56_FX_swipeC2");
  }
}

export class FX_swipeC3 extends Sound {
  constructor() {
    super("55_FX_swipeC3");
  }
}

export class FX_swipeD1 extends Sound {
  constructor() {
    super("54_FX_swipeD1");
  }
}

export class FX_swipeD2 extends Sound {
  constructor() {
    super("53_FX_swipeD2");
  }
}

export class FX_swipeD3 extends Sound {
  constructor() {
    super("52_FX_swipeD3");
  }
}

export class FX_swipeE1 extends Sound {
  constructor() {
    super("51_FX_swipeE1");
  }
}

export class FX_swipeE2 extends Sound {
  constructor() {
    super("50_FX_swipeE2");
  }
}

export class FX_swipeE3 extends Sound {
  constructor() {
    super("49_FX_swipeE3");
  }
}

export class FX_swordSpin extends Sound {
  constructor() {
    super("48_FX_swordSpin");
  }
}

export class FX_textBoxAppear extends Sound {
  constructor() {
    super("47_FX_textBoxAppear");
  }
}

export class FX_thunder extends Sound {
  constructor() {
    super("46_FX_thunder");
  }
}

export class FX_weaponChange extends Sound {
  constructor() {
    super("45_FX_weaponChange");
  }
}

export class MUS_boss extends Sound {
  constructor() {
    super("117_MUS_boss");
  }
}

export class MUS_bossIntro extends Sound {
  constructor() {
    super("116_MUS_bossIntro");
  }
}

export class MUS_ending extends Sound {
  constructor() {
    super("107_MUS_ending");
  }
}

export class MUS_level01 extends Sound {
  constructor() {
    super("87_MUS_level01");
  }
}

export class MUS_level02 extends Sound {
  constructor() {
    super("86_MUS_level02");
  }
}

export class MUS_level03 extends Sound {
  constructor() {
    super("85_MUS_level03");
  }
}

export class MUS_level04 extends Sound {
  constructor() {
    super("84_MUS_level04");
  }
}

export class MUS_level05 extends Sound {
  constructor() {
    super("83_MUS_level05");
  }
}

export class MUS_level06 extends Sound {
  constructor() {
    super("82_MUS_level06");
  }
}

export class MUS_levelSelect extends Sound {
  constructor() {
    super("81_MUS_levelSelect");
  }
}

export class MUS_opening extends Sound {
  constructor() {
    super("72_MUS_opening");
  }
}

export const IMAGE_FILES: string[] = [
  "273_BG_endingCity.jpg",
  "271_BG_endingSunset.jpg",
  "256_BG_fortress1.png",
  "255_BG_fortress2.png",
  "254_BG_fortress3.png",
  "246_BG_grassyPlains.jpg",
  "209_BG_openingCity.jpg",
  "275_BG_openingCrenson.png",
  "274_EFF_dash.png",
  "267_EFF_enemyESlash.png",
  "262_EFF_enemySwipe.png",
  "260_EFF_enemySwordCharge.png",
  "261_EFF_enemySwordChargeBig.png",
  "206_EFF_explode.png",
  "259_EFF_explodeB.png",
  "207_EFF_explodeC.png",
  "257_EFF_explodeSpike.png",
  "243_EFF_playerHit.png",
  "194_EFF_playerTrail.png",
  "195_EFF_playerTrail2.png",
  "174_EFF_shotAbsorb.png",
  "172_EFF_smoke.png",
  "244_EFF_spark.png",
  "171_EFF_strike0.png",
  "170_EFF_strike1.png",
  "169_EFF_strike2.png",
  "168_EFF_strike3.png",
  "167_EFF_strikeX.png",
  "155_EFF_warpInA.png",
  "154_EFF_warpInB.png",
  "242_G_HL1.png",
  "241_G_HL2.png",
  "240_G_HL3.png",
  "175_G_arrow.png",
  "292_G_back.png",
  "158_G_bgCircuit.png",
  "222_G_bgCircuit2.png",
  "282_G_bossBar.png",
  "281_G_bossBarBit.png",
  "279_G_circuitBack.png",
  "277_G_city.jpg",
  "252_G_fortress.png",
  "251_G_fortressCutScene.png",
  "250_G_fortressCutScene2.png",
  "253_G_fortressShadow.png",
  "247_G_gradRed.png",
  "238_G_hudMain.png",
  "234_G_itemSlot.png",
  "229_G_levelTypeHolder.png",
  "228_G_lifeBar.png",
  "227_G_lifeBarBack.png",
  "239_G_lifeOctagon.png",
  "226_G_mapPoint.png",
  "225_G_mapPointCrenson.png",
  "224_G_mapPointCrenson2.png",
  "223_G_mapPointSelected.png",
  "221_G_menuBox.png",
  "220_G_menuBoxNarrow.png",
  "219_G_menuBoxSmall.png",
  "218_G_menuBoxSmallHighlight.png",
  "217_G_messageBox.png",
  "214_G_mmBlob1.png",
  "213_G_mmBlob2.png",
  "210_G_oddityLogo.png",
  "208_G_openingTunnel.png",
  "193_G_portraitHolder.png",
  "183_G_roadStraight.png",
  "182_G_roadTurnBig.png",
  "181_G_roadTurnLong.png",
  "180_G_roadTurnLongB.png",
  "179_G_roadTurnSmall.png",
  "178_G_roadTurnSmallB.png",
  "176_G_robot.png",
  "177_G_robotInner.png",
  "211_G_startMissionBar.png",
  "159_G_textBox.png",
  "156_G_unlockBox.png",
  "304_G_w1.png",
  "303_G_w1s.png",
  "302_G_w2.png",
  "301_G_w2s.png",
  "300_G_w3.png",
  "299_G_w3s.png",
  "298_G_w4.png",
  "297_G_w4s.png",
  "296_G_w5.png",
  "295_G_w5s.png",
  "237_G_weaponBar.png",
  "152_G_whiteFill.jpg",
  "294_G_xenosAlpha.png",
  "150_G_xenosBar.png",
  "151_G_xenosBarBack.png",
  "157_M_title.png",
  "293_SPR_axeShockwave.png",
  "290_SPR_barrierBeam.png",
  "289_SPR_barrierBlock.png",
  "286_SPR_blackhole.png",
  "285_SPR_boss1.png",
  "284_SPR_boss2.png",
  "283_SPR_bossFinal.png",
  "278_SPR_circuit.png",
  "280_SPR_circuit2.png",
  "276_SPR_cleanser.png",
  "263_SPR_enemyA.png",
  "270_SPR_enemyB.png",
  "269_SPR_enemyC.png",
  "268_SPR_enemyD.png",
  "266_SPR_enemyE.png",
  "265_SPR_enemyF.png",
  "230_SPR_enemyLaser.png",
  "264_SPR_enemyShot.png",
  "258_SPR_explodeHuge.png",
  "248_SPR_generator.png",
  "249_SPR_generatorBroken.png",
  "245_SPR_gravityOrb.png",
  "236_SPR_itemHP.png",
  "235_SPR_itemPickup.png",
  "233_SPR_itemXenos.png",
  "231_SPR_knight.png",
  "232_SPR_knightArmoured.png",
  "215_SPR_mine.png",
  "212_SPR_missile.png",
  "185_SPR_portraitDistort.png",
  "184_SPR_rain.png",
  "173_SPR_sickleShot.png",
  "165_SPR_sword.png",
  "166_SPR_swordBack.png",
  "163_SPR_swordTrail.png",
  "164_SPR_swordTrailBack.png",
  "288_blackBlock.png",
  "287_blackBlock2.png",
  "272_endingExplode.png",
  "291_enemyHPBar.png",
  "216_mDot.png",
  "205_pPose1.png",
  "202_pPoseArmour1.png",
  "200_pPoseArmourSunset1.png",
  "201_pPoseArmourSunset2.png",
  "203_pPoseSunset1.png",
  "204_pPoseSunset2.png",
  "199_playerF1.png",
  "198_playerF2.png",
  "197_playerF3.png",
  "196_playerF4.png",
  "192_portrait_A1.jpg",
  "191_portrait_A2.jpg",
  "190_portrait_C1.png",
  "189_portrait_C2.png",
  "188_portrait_G1.png",
  "187_portrait_G2.png",
  "186_portrait_X1.jpg",
  "162_targetF1.png",
  "161_targetF2.png",
  "160_targetF3.png",
  "153_whiteBlock.jpg",
  "146_zone1Block1.png",
  "145_zone1Block2.png",
  "141_zone1Obs.png",
  "137_zone2Block1.png",
  "136_zone2Block2.png",
  "135_zone2Obs.png",
  "124_zone3Block1.png",
  "123_zone3Block2.png",
  "122_zone3Obs.png",
  "144_zoneCityDaybgBottom.jpg",
  "143_zoneCityDaybgMiddle.jpg",
  "142_zoneCityDaybgTop.jpg",
  "149_zoneCitybgBottom.jpg",
  "148_zoneCitybgMiddle.jpg",
  "147_zoneCitybgTop.jpg",
  "140_zoneDaybgBottom.jpg",
  "139_zoneDaybgMiddle.jpg",
  "138_zoneDaybgTop.jpg",
  "134_zoneFortressbgMiddle.jpg",
  "133_zoneNightbgBottom.jpg",
  "132_zoneNightbgMiddle.jpg",
  "131_zoneNightbgTop.jpg",
  "130_zoneSunsetbgBottom.jpg",
  "129_zoneSunsetbgMiddle.jpg",
  "128_zoneSunsetbgTop.jpg",
  "127_zoneUndergroundbgBottom.jpg",
  "126_zoneUndergroundbgMiddle.jpg",
  "125_zoneUndergroundbgTop.jpg",
  "121_zoneVRbg.jpg",
];

export const SOUND_IDS: string[] = [
  "120_FX_appear",
  "119_FX_axeCharge",
  "118_FX_axeShockwave",
  "115_FX_cleanserLoop",
  "114_FX_damage",
  "113_FX_dash",
  "112_FX_death",
  "111_FX_doors",
  "109_FX_effect1",
  "108_FX_effect2",
  "110_FX_effect3",
  "106_FX_enemyShot1",
  "105_FX_enemyShot2",
  "104_FX_enemyShot3",
  "103_FX_enemySlash",
  "102_FX_explode1",
  "101_FX_explode2",
  "100_FX_explode3",
  "99_FX_explode4",
  "98_FX_explode5",
  "97_FX_explode6",
  "96_FX_hit1",
  "95_FX_hit2",
  "94_FX_hit3",
  "93_FX_hitSpecial1",
  "92_FX_hitSpecial2",
  "91_FX_hitSpecial3",
  "90_FX_item1",
  "89_FX_item2",
  "88_FX_item3",
  "80_FX_menuChange1",
  "79_FX_menuChange2",
  "78_FX_menuSelect1",
  "77_FX_mine1",
  "76_FX_mine2",
  "75_FX_missileLaunch",
  "74_FX_missionBar1",
  "73_FX_missionBar2",
  "71_FX_openingBoost",
  "70_FX_openingComputer",
  "69_FX_scytheBlackHole",
  "68_FX_scytheShot",
  "67_FX_shine",
  "66_FX_staffCatch",
  "65_FX_staffSpin",
  "64_FX_staffThrow",
  "63_FX_swipe1",
  "62_FX_swipe2",
  "61_FX_swipe3",
  "60_FX_swipeB1",
  "59_FX_swipeB2",
  "58_FX_swipeB3",
  "57_FX_swipeC1",
  "56_FX_swipeC2",
  "55_FX_swipeC3",
  "54_FX_swipeD1",
  "53_FX_swipeD2",
  "52_FX_swipeD3",
  "51_FX_swipeE1",
  "50_FX_swipeE2",
  "49_FX_swipeE3",
  "48_FX_swordSpin",
  "47_FX_textBoxAppear",
  "46_FX_thunder",
  "45_FX_weaponChange",
  "117_MUS_boss",
  "116_MUS_bossIntro",
  "107_MUS_ending",
  "87_MUS_level01",
  "86_MUS_level02",
  "85_MUS_level03",
  "84_MUS_level04",
  "83_MUS_level05",
  "82_MUS_level06",
  "81_MUS_levelSelect",
  "72_MUS_opening",
];

export const FONTS: { family: string; file: string }[] = [
  { family: "TRS Million", file: "44_Font1_TRS Million.ttf" },
  { family: "PF Ronda Seven", file: "43_Font2_PF Ronda Seven.ttf" },
  { family: "Arial Narrow Embedded", file: "15_Arial Narrow.ttf" },
  { family: "Arial Black Embedded", file: "39_Arial Black.ttf" },
];
